module.exports = __webpack_public_path__ + "img/company9.8c0d4aef.png";